/* global angular, imagesLoaded, $ */
angular.module('ua5App')
    .directive('resourcePostSlideshow', ['$state', '$timeout', '$rootScope', 'PostFactory', function($state, $timeout, $rootScope, PostFactory) {
        return {
            restrict: 'A',
            templateUrl: 'components/resource-post-slideshow/resource-post-slideshow.html',
            scope: {
                slugs: '=',
                contentTitle: '@',
                sectionIndex: '@'
            },
            link: function($scope, element, attrs) {
                var $$element;
                $$element = $(element);
                $scope.currentIndex = 1;
                $scope.content = [];

                for (var i = 0; i < $scope.slugs.length; i++) {
                    PostFactory.post().get({slug: $scope.slugs[i].slug}).$promise.then(function(response) {
                        $scope.content.push(response);
                        if ($scope.content.length === $scope.slugs.length) {
                            initSlick();
                        }
                    });
                }

                $$element.on('afterChange', function(e, slick, i) {
                    $scope.currentIndex = i + 1;
                    $scope.$apply();
                });

                // Options to pass to slick carousel
                $scope.carouselOptions = {
                    nextArrow: $$element.find('.resource-post-slideshow__control--next'),
                    prevArrow: $$element.find('.resource-post-slideshow__control--prev')
                };

                function initSlick() {
                    $timeout(function() {
                        $('.resource-post-slideshow__carousel', element).slick($scope.carouselOptions);
                    }, 10);
                }

                imagesLoaded(element, function() {
                    $rootScope.$broadcast('resourceComponentPosition');
                });

                $timeout(function() {
                    $rootScope.$broadcast('resourceComponentPosition', {sectionIndex: $scope.sectionIndex});
                });
            }
        };
    }])
;
